<template>
  <div class="page entry-page">


    <div class="page-header">
        <div class="page-meta">
         <h1>Unsere Klinker- und Riemchen-Welt</h1>
        </div>
    </div>



      <div :class="'products' + (readyState ? ' ready':'' )">
        
          <div id="loader"></div>
        
          <div class="product-list">
              <div class="product" v-for="(product, i) in filteredProducts" :key="i" v-if="product.attributes.images.length > 0">
<!--              <div class="colorcode"><div class="color" :style=" `background:` + product.attributes.images[0].colorHex "></div><div class="code">R{{product.attributes.images[0].colorRGBA.red}} G{{product.attributes.images[0].colorRGBA.green}} B{{product.attributes.images[0].colorRGBA.blue}}</div></div> -->
                <a class="fav-preview" v-on:click="love_it(product)"><i class="icon icon-favourite " :class=" checkFav(product.articlenumber) && 'icon-favourite-full' " ></i><span>Zu Favoriten</span></a>
                <div class="product-image"><img :src=" config.appUrl + product.attributes.images[0].sizes.small" loading="lazy" width="600" height="600"></div>
                <div class="overlay-artno">
                    <router-link :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber }}">{{product.articlenumber}}</router-link>
                </div>
                <div class="overlay-details">
                    <router-link :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber }}">ansehen</router-link>
                </div>
                
              </div>
          </div>
          
          <div class="produkt-hinweise">
            <p>Alle unsere Verblender/Klinker sind auch als Riemchen verfügbar.</p>
            
          </div>

      </div>

       <div class="product-filter">
         
          <h2>Produkte filtern</h2>
          <div class="filterbox">

            <h4>Farbwelten</h4>
            <div class="farbwelten farbwelten-filter filter-item">
                <div v-for="color in config.product.colors" :key="color.id" class="farbwelt">
                    <input type="checkbox" v-model="filterColors" :checked="filterColors.includes( color.id )" :id="'g-e-'+color.id" :name="color.id" :value="color.id" />
                    <label :class="'gradient ' + color.id" :for="'g-e-'+color.id"></label> <span>{{color.name}}</span>
                  </div>
            </div>

<!--
            <div class="stonetypes stonetypes-filter filter-item">
                <div v-for="stonetype in config.product.properties[2].values" :key="stonetype.id" class="stonetype filter-value">
                    <input type="checkbox" v-model="filterStonetypes" :checked="filterStonetypes.includes( stonetype.id )" :id="'f-'+stonetype.id" :name="stonetype.id" :value="stonetype.id" />
                    <label :for="'f-'+stonetype.id">{{stonetype.name}}</label>
                </div>
            </div>
-->
            
            <h4>Produktart</h4>
            <div class="surfaces surfaces-filter filter-item">

              <div v-for="surface in config.product.properties[1].values" :key="surface.id" class="surface filter-value">
                  <input type="checkbox" v-model="filterSurfaces" :checked=" filterSurfaces == surface.id " :id="'sf-'+surface.id" :name="surface.id" :value="surface.id" />
                  <label :for="'sf-'+surface.id">{{surface.name}}</label>
              </div>
            </div>




          </div>
       </div>

 </div>
</template>
<script>

import config from '../_config/config';

export default {
    name: 'HomePage',
    data: function(){
      return {
        //featuredProducts: [],
        config: null,
        showFeatured: false,
        filterColors: this.$store.state.search.colors, //'blck','yllw','wht','brwn'
        filterSurfaces: this.$store.state.search.surface,
        filterStonetypes: this.$store.state.search.stonetype,
        readyState: false,
      }
    },
  
    computed: {
         search () {
            return this.$store.state.search
        },

        user () {
            return this.$store.state.authentication.user;
        },
        
        products(){
          //console.log(  this.$store.state.products.all );
          return this.$store.state.products.all
        },
        
        
        filteredProducts () {
          
          //console.log( 'computed' );
          //console.log( this.$store.state.search.colors )
          
            this.$store.state.search.colors = this.filterColors
            this.$store.state.search.surface = this.filterSurfaces
            this.$store.state.search.stonetype = this.filterStonetypes
            
          
            var pr = [];
            if(this.showFeatured)
            pr = this.products.filter( ( item ) => { return item.attributes.featured == true && item.attributes.active == true })
            
            else
            pr = this.products.filter( ( item ) => { return item.attributes.active == true })

            pr = pr.filter( ( item ) => { return item.attributes.images.length > 0 && item.attributes.images[0].colorHex })



            if(this.filterColors.length > 0 ) {
                  
                  pr = pr.filter( (item) => { 

                                     var f = false, i;
                                     for (i=0;i<this.filterColors.length;i++) {
                                       if( JSON.stringify( item.attributes.colors ).indexOf( this.filterColors[i] ) > 0 ) f = true;
                                     }
                                     return f
                                });
            }

            if(this.filterSurfaces.length > 0 ) {
              //console.log( pr )
//              pr = pr.filter( ( item ) => { console.log( item.attributes.properties.surface ); return item.attributes.properties.surface == this.filterSurfaces })
              //console.log( pr )

                  pr = pr.filter( (item) => { 

                                     var f = false, i;
                                     for (i=0;i<this.filterSurfaces.length;i++) {
                                       if( JSON.stringify(  item.attributes.properties.surface ).indexOf( this.filterSurfaces[i] ) > 0 ) f = true;
                                     }
                                     return f
                                });

            }




 if(this.filterStonetypes.length > 0 ) {
                  pr = pr.filter( (item) => { 
                                     var f = false, i;
                                     for (i=0;i<this.filterStonetypes.length;i++) {
                                       if( JSON.stringify(  item.attributes.properties.stonetype ).indexOf( this.filterStonetypes[i] ) > 0 ) f = true;
                                     }
                                     return f
                                });
  }




            this.readyState = true

            return pr.slice().sort( function( a,b ){
                         return ( a.attributes.images[0].colorHex < b.attributes.images[0].colorHex ? 1 : 
                                    ( a.attributes.images[0].colorHex > b.attributes.images[0].colorHex ? -1 : 0))
                       });
        },
        
        
    },
    created(){
       // 
        this.config = config
      
/*
      topProducts.forEach( (topitem)=>{
           var topproduct = products.filter((item) => { return item.artnr == topitem.artnr });
          if( topproduct.length > 0) {
            //console.log(topproduct[0] )
            this.productHighlights.push( topproduct[0] );
          }
      })
*/
    },
    methods: {

      checkFav( articlenumber ){
         if(this.user && this.user.fav )
         return ( this.user.fav.filter( (favItem) => { return favItem.articlenumber == articlenumber }).length > 0 ? true:false)
      },

      love_it( product ){   // v-on:click="love_it(product)"
        
        if(!this.user) {
              this.$emit('loginRequired')
              return
              }
        
        var favSchonDrin = this.$store.state.authentication.user.fav.filter( (favItem) => { return favItem.articlenumber == product.articlenumber });
        if( favSchonDrin.length > 0 ) {
//           var i = this.$store.state.authentication.user.fav.indexOf( product.articlenumber )
//           console.log( this.$store.state.authentication.user.fav );
          var i = this.$store.state.authentication.user.fav.findIndex(x => x.articlenumber === product.articlenumber) //indexOf( this.articlenumber )
          this.$store.state.authentication.user.fav.splice(i,1);
//           console.log('splice ' + i);
        }
        else {
          
          var p = {};
            p.id = product.id
            p.articlenumber = product.articlenumber
            p.attributes = product.attributes
          this.$store.state.authentication.user.fav.push( p )
        }
        this.updateFavOnServer()
      },

       updateFavOnServer(){
          const fav = this.user.fav;
          const { dispatch } = this.$store;
          dispatch('fav/update', { fav });
       },      


      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
    }    
};
</script>
<style>



  .entry-page { display: flex; flex-direction: column; }

  .entry-page .products { position: relative; width: 100%; order: 2; }
  .entry-page .product-filter { position: relative; width: 100%; order: 1; overflow: hidden;  } 
  
  .filterbox { position: relative; top: 0; left: 0; background: rgba(0,0,0,0.2); padding: 0.933333em; overflow: auto; -webkit-overflow-scrolling: touch; }

  .product-filter h2 { padding: 1.3333rem 0.73333rem 0.73333rem; }


  .entry-page h1 { text-align: left; }

  
  .entry-page .product-list { display: flex; flex-wrap: wrap; outline: 0 solid green; margin-right: 0px; padding: 0.7333em; }
  .entry-page .product-list .product { flex: 1 1 33.333%; max-width: 33.3333%; position: relative; z-index: 1; padding: 0.222em; margin: 0;  transform: scale(1.001); transition:all 0.3s ease; box-shadow: 0; }
  .entry-page .product-list .product img { display: block; width: 100%; max-width: 100%; height: auto; margin: 0; padding: 0; background: rgba(255,255,255,0.2) }



  /* =======================================================
   * Loading 
   * ======================================================= */
  .entry-page .products .product-list { opacity: 0; transition: opacity 0.3s ease; transition-delay: 1.4s; }
  .entry-page .products.ready .product-list { opacity: 1; }
  
  .entry-page .products #loader { opacity: 1; transition: opacity 0.3s ease; transition-delay: 1.4s;  } 
  .entry-page .products.ready #loader { opacity: 0; }
  
  
  
  @media screen and ( min-width: 40em) {
    .entry-page { display: block; }    
    .entry-page .product-filter { width: 18rem; position: fixed; top: 9rem; right: 0; bottom:0; padding: 0 ; }
    .filterbox { position: absolute; top: 4rem; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.2); padding: 0.933333em; }
    
    .entry-page .product-list { padding: 0 0.73333em; }
    .entry-page .products { margin: -0.2333rem 19rem 0 0; padding-top: 0; width: auto; }
    .entry-page .product-list .product { flex: 0 1 25%; }
    .entry-page .product-filter h2 { }
  }
  
  @media screen and ( min-width: 64.0633em) {      
    .entry-page .product-list .product { flex: 0 1 25%; }
  }

  
  @media screen and ( min-width: 80em) {      
    .entry-page .product-list .product { flex: 0 1 20%; }
  }
  
  .overlay-artno { position: absolute; top: auto; bottom: -1em; left: 0; right: 0;  opacity: 0; transform: translate(0,30px); transition: transform 0.3s, opacity 0.3s ease;  }
  .overlay-artno a { 
    display: block; background: rgba(0,0,0,0.7)  ;
    border-radius: 0; padding: 0.222em 0.43333em 0.3333em; text-decoration: none; font-size: 0.7rem; text-align: center; 
  }

  .overlay-details { position: absolute; top: 50%; margin-top: -1.20rem; right: 0; left: 0; text-align: center; }
  .overlay-details a { display: block; padding:0.0511em 0.633333em; margin: 0 auto; 
    background: rgba(0,0,0,0.7) url(/img/icons-white/search.svg) center center no-repeat; background-size: 1.5rem; text-indent: -9999px; 
    width: 2.5rem; height: 2.5rem;
    border-radius: 2.5rem; 
    text-decoration: none; 
    transform: scale(0.5);
    opacity: 0;
    transition: transform 0.3s, opacity 0.3s ease; 
    font-size: 0.9rem }



  .entry-page .product-list .fav-preview { position: absolute; top: 0.3333rem; right: 0.3333rem; cursor: pointer; } 
  .entry-page .product-list .fav-preview i { transform: scale(0.6); transition: transform 0.3s; }
  .entry-page .product-list .fav-preview:hover i { transform: scale(0.7); }
  .entry-page .product-list .fav-preview span { display: none; }



  .entry-page .product-list .product:hover { z-index: 500; }

  .entry-page .product-list .product:hover .overlay-artno { transform: translate(0,0);  opacity: 1; }
  .entry-page .product-list .product:hover .overlay-details a { transform: scale(1); opacity: 1; }
  .entry-page .product-list .product:hover { transform: scale(1.2); background: rgba(0,0,0,0.6) }
  .entry-page .product-list .product:hover img { box-shadow: 0 0 15px rgba(0,0,0,0.9); }



  .filter-item { padding: 0 0 1.4333em; }

  .farbwelten-filter label { height: 1.9777rem; width: 5.777rem; text-indent: 0; 
      border: 0 solid #fff; display: block; position: relative; max-width: 100%; width: 100% !important; margin: 0; z-index: 99;
      }
  .farbwelten-filter label:after { position: absolute; left: 0.1433rem; top: 0.1433rem; height: 1.6777rem; line-height: 1.6777rem; text-align: center;  width: 1.6777rem; content: "\2717"; text-indent: 0; 
    background: rgba(0,0,0,0.6); border: 0 solid rgba(0,0,0,0.1); color: #fff; border-radius: 3px; 
    transition: background 0.3s ease;
    z-index: 2;
    z-index: 100;
    box-shadow: 0 0 2px rgba(0,0,0,0.4);
  }

  .farbwelten-filter input { display: none; }
  .farbwelten-filter input:checked + label:after { content: "\2714";  color: #fff; background: #52A400; }

  .farbwelten { display: block; }
  .farbwelt { display: flex; margin: 0 0.333em 0.3333em 0; background: rgba(0,0,0,0.6); border-radius: 1px; overflow: hidden; }
  .farbwelt label { flex: 0 0 35%; max-width: 35%; }
  .farbwelt span { display: block; flex: 0 0 65%; max-width: 65%; height: 1.9777rem; line-height: 1.9777rem; padding: 0 0.9333rem; font-size: 0.9rem; }


  .surfaces-filter {}
  .filter-value { background: rgba(0,0,0,0.6); border-radius: 2px; padding: 0.53333em 0.63333em 0.53333em 3em; margin: 0 0 .3333em 0; position: relative; }  
  .filter-value input { display: none; }
  .filter-value label { font-size: 0.9rem; }
  .filter-value label:before { content: ""; display: inline-block; width: 1.6666rem; height: 1.66666rem; line-height: 1.66666rem; content: "\2717"; 
    position: absolute; top: 0.277rem; left: 0.277rem; 
    text-align: center;
    background: rgba(255,255,255,0.1); border-radius: 3px; 
  }  
  .filter-value input:checked + label:before { content: "\2714"; color: #fff; background: #52A400; }


.produkt-hinweise { padding: 0.933333em; }
.produkt-hinweise p { margin: 0; font-size: 0.9rem; }

  .colorcode { position: absolute; bottom: 0.33333em; left: 0.33333em; z-index: 14; background: rgba(0,0,0,0.3);  }
  .colorcode .color { display: inline-block; width: 1.6333rem; height: 1.63333rem; }
  .colorcode .code { display: inline-block; line-height: 1.63333rem; vertical-align: top; font-size: .8rem; padding: 0 0.333rem; }
</style>